










































































import {Component} from 'vue-property-decorator';
import UrlMixin from '../query/url-mixin';
import {mixins} from 'vue-class-component';
import tutorial from './tutorial';
import AffiliateNetwork from '@/services/rest/bemob/affiliate-network';
import TrafficSource from '@/services/rest/bemob/traffic-source';
import Campaign from '@/services/rest/bemob/campaign';
import Offer from '@/services/rest/bemob/offer';
import Landing from '@/services/rest/bemob/landing';

@Component
export default class IntroJS extends mixins(UrlMixin) {
  affiliateNetworkCount = 0;
  trafficSourceCount = 0;
  campaignCount = 0;
  offerCount = 0;
  landingCount = 0;

  get tutorial() {
    return tutorial(this);
  };

  get route() {
    return this.$route.params.type || '';
  }

  quickStart() {
    this.$store.commit('quickStart', !this.$store.state.tutorial.quickStart);
  }

  created() {
    (new AffiliateNetwork())
      .getCount({})
      .then(ans => {
        this.affiliateNetworkCount = ans.data.payload.count;
      });

    (new TrafficSource())
      .getCount({})
      .then(ans => {
        this.trafficSourceCount = ans.data.payload.count;
      });

    (new Campaign())
      .count({})
      .then(ans => {
        this.campaignCount = ans.data.payload.count;
      });

    (new Offer())
      .getCount({})
      .then(ans => {
        this.offerCount = ans.data.payload.count;
      });

    (new Landing())
      .getCount({})
      .then(ans => {
        this.landingCount = ans.data.payload.count;
      });
  }
}
